import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import { EnumStringFieldDefinition } from '@ironsight/form-builder'
import vsWrapper from '@/components/vision/VsWrapper.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsButton from '@/components/vision/VsButton.vue'
import BulkEditComponent from '@/components/form-builder/BulkEditComponent.vue'

interface Props {
  field: {
    selectableOptions: string[]
    isRadio: boolean
    uniqueKey: () => string
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EnumStringFieldSettings',
  props: {
    field: null
  },
  emits: ["modify-field"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'modify-field',
    payload: {
      propertyKey: string
      fieldValue: string[] | boolean
      key: string
    }
  ): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  field: {
    selectableOptions: string[]
    isRadio: boolean
    uniqueKey: () => string
  }
}




const showBulkEdit = ref(false)
const bulkEditText = ref('')

const showUiTypeToggle = computed(
  () => props.field instanceof EnumStringFieldDefinition
)

function toggleUiType(isRadio: boolean) {
  emitChanges('isRadio', isRadio)
}

function addOption() {
  const updatedOptions = [...props.field.selectableOptions, '']
  emitChanges('selectableOptions', updatedOptions)
}

function removeOption(index: number) {
  const updatedOptions = [...props.field.selectableOptions]
  updatedOptions.splice(index, 1)
  bulkEditText.value = updatedOptions.join('\n')
  emitChanges('selectableOptions', updatedOptions)
}

function updateOptionText(text: string, index: number) {
  const updatedOptions = [...props.field.selectableOptions]
  updatedOptions[index] = text
  bulkEditText.value = updatedOptions.join('\n')
  emitChanges('selectableOptions', updatedOptions)
}

function initializeBulkEditText() {
  bulkEditText.value = props.field.selectableOptions.join('\n')
}

function toggleBulkEdit() {
  showBulkEdit.value = !showBulkEdit.value
}

function onBulkEditClicked() {
  initializeBulkEditText()
  toggleBulkEdit()
}

function applyBulkEditOptions(bulkOptions: string[]) {
  emitChanges('selectableOptions', bulkOptions)
  toggleBulkEdit()
}

function emitChanges(propertyKey: string, value: string[] | boolean) {
  emit('modify-field', {
    propertyKey,
    fieldValue: value,
    key: props.field.uniqueKey(),
  })
}

return { __sfc: true,props, emit, showBulkEdit, bulkEditText, showUiTypeToggle, toggleUiType, addOption, removeOption, updateOptionText, initializeBulkEditText, toggleBulkEdit, onBulkEditClicked, applyBulkEditOptions, emitChanges, vsWrapper, VsTextInput, VsButton, BulkEditComponent }
}

})